import { useState } from "react";
import { Message } from "./types/chat";
import { useMutation } from "react-query";
import { agentXMutation } from "ui-io/queries/agent-x-mutation";
export const useChat = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const [loading, setLoading] = useState(false);
  let sessionId = `${Date.now()}-${Math.random()}`;

  const mutation = useMutation(agentXMutation, {
    onSuccess: (result) => {
      const assistantMessage: Message = {
        id: `${Date.now()}-${Math.random()}`,
        role: "assistant",
        content: result.response,
        sessionId: result.sessionId,
        createdAt: Date.now(),
      };

      setMessages((prev) => [...prev, assistantMessage]);
      setLoading(false);
    },
    onError: (err:any) => {
      console.error("Error in agentXMutation:", err);
      const errorMessage: Message = {
        id: `${Date.now()}-${Math.random()}`,
        role: "assistant",
        content: err?.message ? err.message : "Something went wrong. Please try after some moment!",
        isError: true,
        sessionId: "",
        createdAt: Date.now(),
      };

      setMessages((prev) => [...prev, errorMessage]);
      setLoading(false);
    },
  });
  const sendMessage = async (prompt: string) => {
    const userMessage: Message = {
      id: `${Date.now()}-${Math.random()}`,
      role: "user",
      content: prompt,
      sessionId: sessionId,
      createdAt: Date.now(),
    };

    setMessages((prev) => [...prev, userMessage]);

    setLoading(true);
    mutation.mutate({ prompt: prompt, sessionId: sessionId });
  };

  return {
    messages,
    loading,
    sendMessage,
  };
};
